module.exports = __webpack_public_path__ + "5cdeeaaf7dcf9b21e2e1a88a33862c9b.svg";